// The game's few sounds. The corner window's own, off until the player turns them on: a rising three-note bell when
// an Aura appears on the hunt, and a fuller four-note one when it is caught. And the two in Settings (client/golden.ts):
// a quick bright run when a Golden Wild shows, and two soft notes for a catch. Synthesised (no files): each note is a
// sine with a quiet inharmonic partial and a bell's fast attack and long decay.
let ctx: AudioContext | null = null;

const NOTES = {
  'aura-seen': [1318.5, 1975.5, 2637],
  'aura-caught': [1046.5, 1318.5, 1568, 2093],
  golden: [1568, 2093, 2637, 3136],
  catch: [1318.5, 1760],
} as const;
/** Seconds between notes. */
const GAP: Record<keyof typeof NOTES, number> = { 'aura-seen': 0.11, 'aura-caught': 0.085, golden: 0.06, catch: 0.1 };

function bell(a: AudioContext, freq: number, at: number, vol: number) {
  const out = a.createGain();
  out.gain.setValueAtTime(0.0001, at);
  out.gain.exponentialRampToValueAtTime(vol, at + 0.006);
  out.gain.exponentialRampToValueAtTime(0.0001, at + 1.5);
  out.connect(a.destination);
  for (const [mult, level, decay] of [[1, 1, 1.5], [2.76, 0.22, 0.5], [5.4, 0.06, 0.25]] as const) {
    const o = a.createOscillator(), g = a.createGain();
    o.type = 'sine';
    o.frequency.value = freq * mult;
    g.gain.setValueAtTime(level, at);
    g.gain.exponentialRampToValueAtTime(0.0001, at + decay);
    o.connect(g).connect(out);
    o.start(at);
    o.stop(at + decay + 0.05);
  }
}

/** Plays a chime through `win`'s audio. The first call should come from a click, so the browser lets it sound. */
export function chime(win: Window, kind: keyof typeof NOTES, vol = 0.09) {
  try {
    const AC = (win as unknown as { AudioContext?: typeof AudioContext }).AudioContext;
    if (!AC) return;
    if (!ctx || ctx.state === 'closed') ctx = new AC();
    if (ctx.state === 'suspended') void ctx.resume();
    const t = ctx.currentTime + 0.02;
    NOTES[kind].forEach((f, i) => bell(ctx!, f, t + i * GAP[kind], vol * (1 - i * 0.12)));
  } catch { /* no audio here */ }
}

/** Drop the audio context with the window that made it. */
export function closeChime() {
  try { void ctx?.close(); } catch { /* already gone */ }
  ctx = null;
}
